module.exports = __webpack_public_path__ + "static/media/card-Visa.9049558e.svg";